// @flow
import React from "react";

const NotFound = () => <div className="not-found"> Page not found </div>;

export default NotFound;



// WEBPACK FOOTER //
// ./app/components/commons/404/notFound.js